import { UserPayPlanCode } from "../constant/user-constants/user-pay-plan-code.constants";

export class User {
  RecordId?: number;
  Id?: number;
  Email: string;
  EmployeeNumber: string;
  FirstName: string;
  LastName: string;
  IsFieldWorker: boolean;
  IsTimeUser: boolean;
  OrganizationId: number;
  OrganizationName: string;
  OrganizationLogo?: string;
  PhoneNumber: string;
  Roles: string[];
  UserGuid: string;
  IsBadgePhotoVerified: boolean;
  BadgePhotoFilename?: string;
  BadgePhoto?: string;
  ApplicationRoleName: string;
  IsDeleted: boolean;
  IsActive: boolean;
  HomeState?: string;
  HomeDepartment?: string;
  PayPlanCode?: UserPayPlanCode;
  IsExempt: boolean;


  constructor(obj?: Partial<User>) {
    if (obj) {
      Object.assign(this, obj);
    } else {
      throw Error('Object cannot be null');
    }
  }

  getName(format = 'First Last') {
    if (format === 'First Last') {
      return this.FirstName + ' ' + this.LastName;
    } else if (format === 'Last, First') {
      return this.LastName + ', ' + this.FirstName;
    } else {
      return this.FirstName + ' ' + this.LastName;
    }
  }

  isSoftDeleted(): boolean {
    return this.IsDeleted;
  }
}
